<div class="client-task-modal-attachments">
  <!-- <label class="h5" style="margin: 0"
  ><i class="feather paperclip"></i>
  <span style="font-weight: 600"> Attachments to Send</span></label
  > -->

  <div class="file-items">
    @for (selectedFile of job.files; track selectedFile; let i = $index) {
      <div class="file-item">
        <i
          class="file-icon file-{{ selectedFile.ext }}"
          style="background: url('{{ selectedFile.url }}')"
        ></i>
        <div class="file-name" (click)="openFile(selectedFile)">
          {{ selectedFile.filename }}
        </div>
        <a class="color-red-hover">
          <i
            class="feather trash-2"
            (click)="
              deleteFile(
                selectedFile.id != null ? selectedFile.id : selectedFile.url
              )
            "
          ></i>
        </a>
        <a tooltip="Uploaded">
          @if (selectedFile.id != null) {
            <i class="feather check"></i>
          }
        </a>
      </div>
    }
  </div>

  <div
    (click)="openModalFileUpload()"
    class="new-tracked-item"
    style="
      padding: 5px 16px;
      width: 135px;
      font-size: 1rem;
      border-radius: 50px;
    "
  >
    <i class="feather upload" style="font-size: 16px"></i> Select files
  </div>
  @if (toggleShowUploadButton) {
    <button
      class="btn btn-primary"
      (click)="uploadFiles()"
      [disabled]="job.files.length == 0"
    >
      Upload Files
    </button>
  }
</div>
<!-- <div class="attachments-content">
<div class="file-items">
  <div
    class="file-item"
    *ngFor="let file of job.files"
    filePreview
    [type]="file.ext"
    [etag]="file.etag"
    [file]="file"
    >
    <i
      class="file-icon file-{{ file.ext }}"
      style="background: url('{{ file.url }}')"
    ></i>
    <div class="file-name">{{ file.filename }}</div>
  </div>
</div>
</div> -->
